import { gql } from "@apollo/client";

export const CURRENT_USER_ACCOUNT = gql`
  query currentUserAccount {
    currentUserAccount {
      id
      name
      address
      url
      brandColor
      criticalSubtaskBg
      mainLogoUrl
      smallLogoUrl
    }
  }
`;

export const Accounts_Data = gql`
  query allUserAccount($ldmsOnly: Boolean) {
    allUserAccount(ldmsOnly: $ldmsOnly) {
      id
      name
      address
      url
      mainLogoUrl
      smallLogoUrl
      criticalSubtaskBg
      brandColor
      emailLogin
      numberLogin
      selfRegistration
      address2
      numberOfRoles
      clanNeeded
      dartsNeeded
      lenseNeeded
      numberLogin
      emailLogin
    }
  }
`;

export const Role_Account_Query = gql`
  query getAllJobrole($accountId: Int) {
    getAllJobrole(accountId: $accountId) {
      id
      name
      numberLogin
      emailLogin
      targetEditDays
      inputEditDays
      pocEmail
      pocName
      pocContactNumber
      clanNeeded
      dartsNeeded
      dartsFormNeeded
      mandatoryTimeDistribution
      signInSignOutRequired
      locationRequired
      ldmsNeeded
      mirrorNeeded
      clanNeeded
      dartsFormNeeded
      dartsNeeded
      account {
        id
        name
      }
    }
  }
`;

export const CURRENT_USER_PROFIILE = gql`
  query currentUserProfile {
    currentUserProfile {
      id
      name
      surname
      profilePicture
      roleId
      role
      userType {
        id
        userType
      }
    }
  }
`;

export const GET_LEAD_FIELDS_FOR_JOBROLE = gql`
  query getLeadFieldsForJobrole($jobroleId: Int!) {
    getLeadFieldsForJobrole(jobroleId: $jobroleId) {
      id
      leadName
      email
      contactNumber
      status {
        id
        statusName
        statusColor
      }
      stage {
        id
        stageName
        stageColor
      }
      customFields {
        id
        fieldName
        fieldType
        fieldValue
        rank
        hintText
        reValidation
        reValidationText
        maxLines
        isRequired
      }
    }
  }
`;



export const ADD_UPDATE_COMPANY_DETAILS = gql`
  mutation addUpdateCompanyDetails(
    $roleId: Int!
    $companyName: String!
    $companyId: Int
    $orderValue: Int
    $closureDate: Date
    $companyContract: String
    $document: Upload
  ) {
    addUpdateCompanyDetails(
      roleId: $roleId
      companyName: $companyName
      companyId: $companyId
      orderValue: $orderValue
      closureDate: $closureDate
      companyContract: $companyContract
      document: $document
    ) {
      success
      message
      data {
        id
        companyName
        roleId
        orderValue
        closureDate
        companyContract
        documentUrl
      }
    }
  }
`;

export const ADD_UPDATE_USER_RESPONSE = gql`
  mutation addUpdateUserResponsesForQuestion(
    $questionId: Int!
    $response: String!
    $formUuid: String!
    $formDate: Date!
    $parentFormUuid: String
  ) {
    addUpdateUserResponsesForQuestion(
      questionId: $questionId
      response: $response
      formUuid: $formUuid
      formDate: $formDate
      parentFormUuid: $parentFormUuid
    ) {
      data {
        id
        questionId
        formUuid
        response
      }
    }
  }
`;

export const ADD_UPDATE_LEAD = gql`
  mutation addUpdateLeadProfile($leadProfile: AddUpdateLeadProfileInput!) {
    addUpdateLeadProfile(leadProfile: $leadProfile, assignToUser: false) {
      success
      message
      data {
        id
        leadName
        email
        contactNumber
      }
    }
  }
`;

export const ADD_UPDATE_USER_RESPONSES_FOR_QUESTIONS = gql`
  mutation addUpdateUserResponsesForQuestions(
    $responses: [FormQuestionOptionInput!]!
    $assignToUser: Boolean
  ) {
    addUpdateUserResponsesForQuestions(
      responces: $responses
      assignToUser: $assignToUser
    ) {
      success
      message
      data {
        id
        questionId
        formUuid
        response
        modifiedAt
        modifiedBy
      }
    }
  }
`;

export const DELETE_LEAD = gql`
  mutation DeleteLead($leadId: Int!) {
    deleteLead(leadId: $leadId) {
      success
      message
      data
    }
  }
`;

export const UPDATE_LEAD_ASSIGNMENT = gql`
  mutation updateLeadAssignment($leadId: Int!, $userId: Int!) {
    updateLeadAssignment(leadId: $leadId, userId: $userId) {
      success
      message
      data {
        id
        leadName
        email
        contactNumber
        leadCreatedAt
      }
    }
  }
`;

export const GET_JOBROLE_LEADS = gql`
  query getAllJobroleLeads(
    $searchTerm: String!
    $pagingCriteria: PagingCriteria
    $jobroleId: Int!
    $stageId: Int
  ) {
    getAllJobroleLeads(
      jobroleId: $jobroleId
      searchTerm: $searchTerm
      pagingCriteria: $pagingCriteria
      stageId: $stageId
    ) {
      data {
        id
        status {
          id
          statusName
          statusColor
        }
        stage {
          id
          stageName
          stageColor
        }
        assignedUser {
          id
          name
          phoneNumber
        }
        assignedDate
        customFields {
          id
          fieldName
          fieldType
          fieldValue
          rank
          hintText
          reValidation
          reValidationText
          maxLines
          isRequired
        }
      }
      pageMeta {
        nextPage
        previousPage
        hasNextPage
        hasPreviousPage
        totalCount
      }
    }
  }
`;

export const GET_LEAD_DETAILS = gql`
  query getLeadForLeadId($leadId: Int!) {
    getLeadForLeadId(leadId: $leadId) {
      id
      status {
        id
        statusColor
        statusName
      }
      stage {
        id
        stageColor
        stageName
      }
      assignedUser {
        id
        name
        phoneNumber
      }

      assignedDate
      leadSourcedFrom
      leadCreatedAt
      leadFormDetails {
        id
        name
        formUuid
        isEditable
        parentFormUuid
        questions {
          id
          question
          questionType
          answerType
          hintText
          maxLines
          isEnabled
          isMandatoryField
          referenseFormId
          toView
          userResponse {
            formUuid
            response
          }
          reValidation
          reValidationText
        }
      }
      leadExternalDetails {
        id
        formUuid
        isEditable
        parentFormUuid
        name
        questions {
          id
          question
          questionType
          answerType
          hintText
          maxLines
          isEnabled
          isMandatoryField
          referenseFormId
          toView
          userResponse {
            formUuid
            response
          }
          reValidation
          reValidationText
        }
      }
    }
  }
`;

export const MOVE_LEAD_FROM_PRESALES_TO_SALES = gql`
mutation moveLeadFromPresalesToSales ($presalesFormUuid: String!) {
    moveLeadFromPresalesToSales (presalesFormUuid: $presalesFormUuid) {
        success
        message
    }
}
`;

export const VALIDATION_TO_MOVE_LEAD_TO_SALES = gql`
query validationForMovingLeadsFromOneStageToAnother ($leadCurrentStageId: Int!, $leadCategoryId: Int!) {
    validationForMovingLeadsFromOneStageToAnother (leadCurrentStageId: $leadCurrentStageId, leadCategoryId: $leadCategoryId)
}
`;

export const GET_LEAD_ACTIVITY = gql`
  query GetLeadsAndActivityLogs(
    $leadId: Int!
    $pagingCriteria: PagingCriteria
  ) {
    getLeadsAndActivityLogs(leadId: $leadId, pagingCriteria: $pagingCriteria) {
      data {
        log {
          ... on LeadActivityLog {
            id
            activity {
              id
              activityMethod
              activityName
            }
            activityStatus {
              statusName
              id
            }
            remarks
            createdAt
            callDurationSeconds
            modifiedAt
            backDatedEntry
            futureEntry
            activityTimestamp
            meetingMomFilepath
            meeting {
              id
              meetingEndDatetime
              meetingStartDatetime
              meetingStatus
              location
            }
          }

          ... on LeadStageLog {
            id
            fromStage {
              id
              stageName
              stageColor
            }
            toStage {
              id
              stageColor
              stageName
            }
            actionType
            transitionTimeSec
            ldmsStatus {
              id
              statusName
              statusColor
            }
            remarks
            createdAt
            modifiedAt
            backDatedEntry
            activityTimestamp
          }
        }
      }
      pageMeta {
        nextPage
        previousPage
        hasNextPage
        hasPreviousPage
        totalCount
      }
    }
  }
`;

export const UPDATE_LEADS_STAGE_REMARKS = gql`
  mutation UpdateLeadStageRemarks($leadStageLogId: Int!, $remarks: String!) {
    updateLeadStageRemarks(leadStageLogId: $leadStageLogId, remarks: $remarks) {
      success
      message
      data {
        id
        fromStage {
          id
        }
        toStage {
          id
        }
        actionType
        ldmsStatus {
          id
        }
        remarks
        createdAt
        modifiedAt
      }
    }
  }
`;

export const GET_FLS_DETAIILS_NORMAL = gql`
  query getOnlyUsersForRole(
    $accountId: Int!
    $jobroleId: Int!
    $searchTerm: String!
    $pagingCriteria: PagingCriteria
  ) {
    getOnlyUsersForRole(
      accountId: $accountId
      jobroleId: $jobroleId
      searchTerm: $searchTerm
      pagingCriteria: $pagingCriteria
    ) {
      data {
        id
        name
        profilePicture
        employeeId
        email
        phoneNumber
        roleStartDate
        cityName
        stateName
      }
      pageMeta {
        nextPage
        previousPage
        hasNextPage
        hasPreviousPage
        totalCount
      }
    }
  }
`;

export const LIST_USER_MEETINGS = gql`
  query ListUserMeetings($fromDate: DateTime!, $toDate: DateTime!) {
    listUserMeetings(fromDate: $fromDate, toDate: $toDate) {
      id
      activity {
        id
        activityName
        activityMethod
      }
      activityStatus {
        id
        statusName
      }
      remarks
      createdAt
      modifiedAt
      meeting {
        id
        meetingStartDatetime
        meetingEndDatetime
        location
        meetingStatus
      }
      leadDetails {
        id
        assignedDate
        customFields {
          id
          fieldType
          fieldValue
        }
        leadFormDetails {
          id
          name
          formUuid
          questions {
            userResponse {
              formUuid
              response
            }
          }
        }

        leadCategory {
          id
          categoryName
        }
      }
    }
  }
`;

export const USER_PROFILE = gql`
  query userProfile($userId: Int!) {
    userProfile(userId: $userId) {
      id
      name
      employeeId
      email
      phoneNumber
      location
      joiningDate
      genderId
      address
      city
      cityName
      state
      stateName
      zone
    }
  }
`;

export const GET_FLS_DETAIILS = gql`
  query getOnlyUsersForRoleWithSkipTop(
    $jobroleId: Int!
    $searchTerm: String!
    $pagingCriteria: PagingCriteriaWithSkipTop
  ) {
    getOnlyUsersForRoleWithSkipTop(
      jobroleId: $jobroleId
      searchTerm: $searchTerm
      pagingCriteria: $pagingCriteria
    ) {
      data {
        id
        name
        profilePicture
        employeeId
        email
        phoneNumber
        roleStartDate
        cityName
        stateName
      }
      pageMeta {
        totalCount
        totalPages
        currentPage
        limit
        hasNextPage
        hasPreviousPage
        totalCount
      }
    }
  }
`;

export const FLS_OVERVIEW = gql`
  query GetLeadsCountAssignedToUser(
    $startDate: DateTime!
    $endDate: DateTime!
    $userId: Int!
  ) {
    getLeadsCountAssignedToUser(
      startDate: $startDate
      endDate: $endDate
      userId: $userId
    )
  }
`;

export const GET_LEAD_STATS = gql`
  query getAssignedAndUnassignedLeadsCount($jobroleId: Int!) {
    getAssignedAndUnassignedLeadsCount(jobroleId: $jobroleId) {
      total
      assigned
      unassigned
    }
  }
`;

export const GET_ASSIGNED_UNASSIGNED_LEADS = gql`
  query getAssignedOrUnassignedLeadsForLifetimeOnJobrole(
    $searchTerm: String!
    $pagingCriteria: PagingCriteriaWithSkipTop
    $jobroleId: Int!
    $lifetime: Boolean!
  ) {
    getAssignedOrUnassignedLeadsForLifetimeOnJobrole(
      jobroleId: $jobroleId
      searchTerm: $searchTerm
      pagingCriteria: $pagingCriteria
      lifetime: $lifetime
    ) {
      data {
        id
        status {
          id
          statusName
          statusColor
        }
        stage {
          id
          stageName
          stageColor
        }
        assignedUser {
          id
          name
          phoneNumber
        }
        assignedDate
        leadFormDetails {
          id
          name
          formUuid
          isEditable
          parentFormUuid
          questions {
            id
            question
            questionType
            answerType
            hintText
            maxLines
            isEnabled
            isMandatoryField
            referenseFormId
            toView
            userResponse {
              formUuid
              response
            }
            reValidation
            reValidationText
          }
        }
      }
      pageMeta {
        totalCount
        totalPages
        currentPage
        limit
        hasNextPage
        hasPreviousPage
        totalCount
      }
    }
  }
`;

export const GET_BULK_UPLOAD_AUDIT_TRAIL = gql`
query getBulkUploadAuditTrail ($userId: Int) {
    getBulkUploadAuditTrail (userId: $userId) {
        id
        formId
        excelUrl
        errorExcelUrl
        uploadedBy
        uploadedAt
        modifiedAt
    }
} 
`

export const GET_STAGE_COUNTS = gql`
  query getCountStageForJobrole($jobroleId: Int!, $userId: Int) {
    getCountStageForJobrole(jobroleId: $jobroleId, userId: $userId) {
      id
      stageName
      count
      colorCode
      leadCategoryId
    }
  }
`;

export const GET_STATUS_COUNTS = gql`
  query getCountStatusForJobrole($jobroleId: Int!, $userId: Int) {
    getCountStatusForJobrole(jobroleId: $jobroleId, userId: $userId) {
      id
      statusName
      count
      colorCode
      leadCategoryId
    }
  }
`;

export const GET_FLS_STATS = gql`
  query getCountOfActiveInactiveUsers($roleId: Int) {
    getCountOfActiveInactiveUsers(roleId: $roleId) {
      activeUsers
      inactiveUsers
    }
  }
`;

// export const GET_ALL_STAGES = gql`
//   query getAllStagesForJobrole($jobroleId: Int) {
//     getAllStagesForJobrole(jobroleId: $jobroleId) {
//       id
//       stageName
//       stageColor
//     }
//   }
// `;

export const GET_ALL_STAGES = gql`
  query getAllStagesForLeadCategory($leadCategoryId: Int) {
    getAllStagesForLeadCategory(leadCategoryId: $leadCategoryId) {
      id
      stageName
      stageColor
    }
  }
`;

export const GET_ALL_STATUS = gql`
  query getAllStatusForLeadCategory($leadCategoryId: Int!) {
    getAllStatusForLeadCategory(leadCategoryId: $leadCategoryId) {
      id
      statusColor
      statusName
    }
  }
`;

export const GET_ALL_ACTIVITIES = gql`
  query GetAllActivitiesForUser($leadCategoryId: Int!) {
    getAllActivitiesForUser(leadCategoryId: $leadCategoryId) {
      id
      activityName
      activityMethod
    }
  }
`;

export const ADD_UPDATE_LEAD_ACTIVITY_LOG = gql`
  mutation AddUpdateLeadActivity(
    $leadId: Int!
    $activityId: Int!
    $activityMethod: String!
    $activityStatusId: Int
    $remarks: String
    $activityLogId: Int
    $location: String
    $meetingType: String
    $meetingStartDatetime: DateTime
    $meetingEndDatetime: DateTime
    $meetingId: Int
    $callDurationSeconds: Int
    $activityTimestamp: DateTime
    $reminders: [String!]
    $meetingMomUpload: Upload
  ) {
    addUpdateLeadActivity(
      leadId: $leadId
      activityId: $activityId
      activityMethod: $activityMethod
      activityStatusId: $activityStatusId
      remarks: $remarks
      activityLogId: $activityLogId
      location: $location
      meetingType: $meetingType
      meetingStartDatetime: $meetingStartDatetime
      meetingEndDatetime: $meetingEndDatetime
      meetingId: $meetingId
      reminders: $reminders
      callDurationSeconds: $callDurationSeconds
      activityTimestamp: $activityTimestamp
      meetingMomUpload: $meetingMomUpload 
    ) {
      success
      message
      data {
        id
        activity {
          id
          activityMethod
          activityName
        }
        activityStatus {
          id
          statusName
        }
        remarks
        createdAt
        modifiedAt
        callDurationSeconds
        meetingMomFilepath
        meeting {
          id
          meetingStartDatetime
          meetingEndDatetime
          meetingStatus
          location
        }
      }
    }
  }
`;

export const GET_HEADQUARTERS = gql`
query getHeadquarters ($companyName: String!, $sourceId: Int!, $targetId: Int!) {
    getHeadquarters (companyName: $companyName, sourceId: $sourceId, targetId: $targetId) {
        companyName
        headquarters
    }
}
`

export const BULK_UPLOAD_LEADS = gql`
mutation bulkUploadLeads ($formId: Int!, $document: Upload!, $assignToUser: Boolean!) {
    bulkUploadLeads (formId: $formId, document: $document, assignToUser: $assignToUser) {
        success
        message
        data
    }
}
`

export const GET_ALL_STATUS_FOR_ACTIVITY = gql`
  query GetAllStatusForActivity($activityId: Int!) {
    getAllStatusForActivity(activityId: $activityId) {
      id
      statusName
    }
  }
`;

export const GET_ALL_STAGES_FOR_LEAD_CATEGORY = gql`
  query GetAllStagesForLeadCategory($leadCategoryId: Int!) {
    getAllStagesForLeadCategory(leadCategoryId: $leadCategoryId) {
      id
      stageColor
      stageName
      acceptedStatus
    }
  }
`;

export const GET_ALL_STATUS_FOR_LEAD_CATEGORY = gql`
  query GetAllStatusForLeadCategory($leadCategoryId: Int!) {
    getAllStatusForLeadCategory(leadCategoryId: $leadCategoryId) {
      id
      statusColor
      statusName
    }
  }
`;

export const UPDATE_LEAD_STATUS = gql`
  mutation UpdateLeadStatus(
    $leadId: Int!
    $statusId: Int!
    $activityTimestamp: DateTime
  ) {
    updateLeadStatus(
      leadId: $leadId
      statusId: $statusId
      activityTimestamp: $activityTimestamp
    ) {
      success
      message
      data
    }
  }
`;

export const UPDATE_LEAD_STAGE = gql`
  mutation UpdateLeadStage(
    $leadId: Int!
    $stageId: Int!
    $activityTimestamp: DateTime
  ) {
    updateLeadStage(
      leadId: $leadId
      stageId: $stageId
      activityTimestamp: $activityTimestamp
    ) {
      success
      message
      data
    }
  }
`;

export const GET_LEAD_FOR_LEAD_ID = gql`
  query getLeadFoLeadId($leadId: Int!) {
    getLeadForLeadId(leadId: $leadId) {
      id
      leadName
      email
      contactNumber
      status {
        id
        statusColor
        statusName
      }
      stage {
        id
        stageColor
        stageName
      }
      assignedUser {
        id
        name
        profilePicture
      }
      assignedDate
      leadSourcedFrom
      leadCreatedAt
      leadFormDetails {
        id
        name
        formUuid
        isEditable
        parentFormUuid
        questions {
          id
          question
          questionType
          answerType
          hintText
          maxLines
          isEnabled
          isMandatoryField
          referenseFormId
          toView
          userResponse {
            formUuid
            response
          }
          reValidation
          reValidationText
        }
      }
    }
  }
`;

export const GET_USER_FORMS = gql`
  query getUserForms($roleId: Int!) {
    getUserForms(roleId: $roleId) {
      id
      name
      formUuid
      isEditable
      parentFormUuid
    }
  }
`;

export const GET_USER_FORM = gql`
  query getUserForm($formId: Int!, $formUuid: String!) {
    getUserForm(formId: $formId, formUuid: $formUuid) {
      id
      name
      formUuid
      isEditable
      parentFormUuid
      questions {
        id
        question
        questionType
        answerType
        hintText
        maxLines
        isEnabled
        isMandatoryField
        referenseFormId
        options {
          ... on Form {
            id
          }
          ... on Option {
            id
            option
            dependentQuestionId
          }
        }
        userResponse {
          formUuid
          response
          modifiedBy
          modifiedAt
        }
        reValidation
        reValidationText
        toView
        isDependent
        gqlQuery
        gqlPayload
        saveValue
        viewValue
      }
    }
  }
`;

export const GET_ALL_LEAD_CATEGORIES = gql`
  query getAllLeadCategories($roleId: Int) {
    getAllLeadCategories(roleId: $roleId) {
      id
      categoryName
      userId
      isLead
      newCount
      existingCount
      totalCount
    }
  }
`;

export const GET_CRITICAL_LEADS = gql`
  query getCriticalLeads(
    $jobroleId: Int!
    $leadCategoryId: Int!
    $userId: Int!
    $records: Int!
  ) {
    getCriticalLeads(
      jobroleId: $jobroleId
      leadCategoryId: $leadCategoryId
      userId: $userId
      records: $records
    ) {
      id
      leadName
      email
      contactNumber
      assignedDate
      leadSourcedFrom
      leadCreatedAt

      status {
        id
        statusColor
        statusName
      }

      stage {
        id
        stageColor
        stageName
      }

      assignedUser {
        id
        name
        phoneNumber
      }

      leadLastStageMoment {
        id
        createdAt
        toStage {
          id
          stageName
          stageColor
        }
        fromStage {
          id
          stageName
          stageColor
        }
      }

      leadFormDetails {
        id
        name
        formUuid
        isEditable
        parentFormUuid
        questions {
          id
          question
          questionType
          answerType
          hintText
          maxLines
          isEnabled
          isMandatoryField
          referenseFormId
          toView
          isDependent
          gqlQuery
          saveValue
          viewValue
          reValidation
          reValidationText
          userResponse {
            formUuid
            response
          }
        }
      }
    }
  }
`;

export const GET_QUESTIONS_UNIQUE_RESPONSE = gql`
  query getQuestionsUniqueResponse(
    $jobroleId: Int!
    $questionId: Int!
    $searchTerm: String!
    $pagingCriteria: PagingCriteriaWithSkipTop
    $userId: Int
  ) {
    getQuestionsUniqueResponse(
      jobroleId: $jobroleId
      questionId: $questionId
      searchTerm: $searchTerm
      pagingCriteria: $pagingCriteria
      userId: $userId
    ) {
      data {
        response
        totalCount
        companyDetails {
          id
          roleId
          companyContract
          closureDate
          orderValue
          documentUrl
        }
      }
      pageMeta {
        totalCount
        totalPages
        currentPage
        limit
        hasNextPage
        hasPreviousPage
        totalCount
      }
    }
  }
`;

export const GET_ALL_CATEGORIES_LEADS = gql`
  query getAllCategoriesLeads(
    $jobroleId: Int!
    $leadCategoryId: Int!
    $searchTerm: String!
    $pagingCriteria: PagingCriteriaWithSkipTop
    $stageId: Int
    $statusId: Int
    $userId: Int
    $startDate: DateTime
    $endDate: DateTime
    $companyName: String
    $questionId: Int
  ) {
    getAllCategoriesLeads(
      jobroleId: $jobroleId
      leadCategoryId: $leadCategoryId
      searchTerm: $searchTerm
      pagingCriteria: $pagingCriteria
      stageId: $stageId
      statusId: $statusId
      userId: $userId
      startDate: $startDate
      endDate: $endDate
      companyName: $companyName
      questionId: $questionId
    ) {
      data {
        id
        leadName
        email
        contactNumber
        assignedDate
        leadSourcedFrom
        leadCreatedAt
        status {
          id
          statusColor
          statusName
        }
        stage {
          id
          stageColor
          stageName
        }
        assignedUser {
          id
          name
          surname
          phoneNumber
        }
        leadGenerator{
          id
          name
          surname
      }  
        leadLastStageMoment {
          id
          toStage {
            id
            stageName
            stageColor
          }
          fromStage {
            id
            stageName
            stageColor
          }
          createdAt
        }
        leadFormDetails {
          id
          name
          formUuid
          isEditable
          parentFormUuid
          questions {
            id
            question
            questionType
            answerType
            hintText
            maxLines
            isEnabled
            isMandatoryField
            referenseFormId
            toView
            userResponse {
              formUuid
              response
            }
            reValidation
            reValidationText
            toView
            isDependent
            gqlQuery
            saveValue
            viewValue
          }
        }
      }
      pageMeta {
        totalCount
        totalPages
        currentPage
        limit
        hasNextPage
        hasPreviousPage
        totalCount
      }
    }
  }
`;
